import React, {CSSProperties} from 'react';
import {useAnnouncerSlot} from './useAnnouncerSlot';

// Visually hides the live regions while keeping them in the accessibility tree
const srOnly: CSSProperties = {
  position: 'absolute',
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: 0,
};

/**
 * Always-mounted, visually-hidden live-region pair (polite + assertive) for
 * WCAG 4.1.3 status messages. Listens for events dispatched by `announce()`.
 */
export const AnnouncerContainer: React.FC = () => {
  const politeState = useAnnouncerSlot('polite');
  const assertiveState = useAnnouncerSlot('assertive');

  return (
    <div data-testid="liveRegionAnnouncer">
      <div
        data-testid="liveRegionAnnouncer-polite"
        role="status"
        aria-live="polite"
        aria-atomic="true"
        style={srOnly}
      >
        {politeState.message}
      </div>
      <div
        data-testid="liveRegionAnnouncer-assertive"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        style={srOnly}
      >
        {assertiveState.message}
      </div>
    </div>
  );
};
